<template>
  <div class="result-content">
    <div class="result-list">
      <div v-for="(item, key) in quotesResultList" 
            :key="key" 
            class="result-group-wrap">
          <h3 class="result-city-title">{{item.CityName}}</h3>
        <div  v-for="(item2, key2) in item.HotelQuota"
              :key="key2"
              class="result-group">
            <h4 class="result-hotel-title">{{item2.HotelName}}</h4>
          <div v-for="(item3, key3) in item2.HotelQuotasInfoFew"
               :key="key3"
               class="result-row">
            <div class="result-name-block">
              {{ checkRoomKey(item3.Quota[0]) }}
            </div>
            <div 
                 class="result-duration-block">
                {{item3.Key.LongMinMax === "0" ? "" : item3.Key.LongMinMax}}
            </div>
            <div class="result-quotes-block">
              <ul class="quotes-list" :style="gridTemplateColumnsStyle">
                <li v-for="(item4, key4) in filterQuotaByDate(item3.Quota)"
                     @mouseleave="hidePopover()"
                     @mouseenter="showPopover(checkQuotaDescription(item4.QuotaStatus, 'popup'), $event)"
                    :key="key4"
                    :class="['quotes-list-item', 'quotes-list-item-color-' + checkPlacesStatus(item4)]">
                  {{checkQuotaDescription(item4.QuotaStatus, 'cell')}}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: "quotes-result-list",
  data() {
    return {
      quotesResultList: [],
      quotaDescriptionDefault: {
        fewSeatsQuotaDescription: "3",
        noSeatsQuotaDescription: "-",
        reqSeatsQuotaDescription: "?",
        seatsQuotaDescription: "+",
      },
      columns: 0
    }
  },
  mounted() {
    this.setResult()
  },
  computed: {
    gridTemplateColumnsStyle() {
      return {
        'grid-template-columns': `repeat(${this.columns}, 48px)`,
      };
    },
    getResultList() {
        return this.$store.getters['quotes/getSearchResult']
    },
    getDatesISO() {
        return this.$store.getters['quotes/getDatesISO']
    },
    getQuotaDescription() {
        return this.$store.getters['quotes/getQuotaDescription']
    },
    getSettings() {
        return this.$store.getters['getSettings']
    },
  },
  methods: {
    showPopover(text, e, nowrap = true) {
      if (!text || text.length == 0) return;

      let rect = e.target.getBoundingClientRect();
      let res = {
        x: rect.left + (rect.width / 2),
        y: rect.top,
        text: text?.replaceAll('\n', '<br>'),
        height: rect.height,
        nowrap
      };
      this.$store.dispatch("A_SHOW_POPOVER", res)
    },
    filterQuotaByDate(quota) {
      // Инициализируем новый массив с пустыми объектами в зависимости от длины this.getDatesISO
      let result = new Array(this.getDatesISO.length).fill({});
      // Определяем количество колонок
      this.columns = this.getDatesISO.length;
      // Перебираем каждую дату в this.getDate ISO
      this.getDatesISO.forEach((dateISO, index) => {
        // Ищем элемент квоты, соответствующий текущей дате
        const matchingQuotaItem = quota.find(item => 
          moment(item.Date).format('YYYY-MM-DD') === moment(dateISO).format('YYYY-MM-DD')
        );
        // Если соответствующий элемент квоты найден, помещаем его в соответствующий индекс
        if (matchingQuotaItem) {
          result[index] = { ...matchingQuotaItem, dateMatchIndex: index };
        }
      });

      return result;
    },
    checkQuotaDescription(item, mode) {
      if (!item) return;

      if (item.PlacesStatus === 1 && item.IsFewPlaces && item.FreePlaces) {
        const placesLeft = item.FreePlaces === 1 ? 'placesLeft1' : (item.FreePlaces < 5 && item.FreePlaces !== 0 ? 'placesLeft2': 'placesLeft3');
        const text = `${this.localizeList.fewPlaces} (${this.localizeList[placesLeft].replace("{}", item.FreePlaces).toLowerCase()})`;
        return mode === 'cell' ? item.FreePlaces : text;
      } else if (item.PlacesStatus === 1 && item.IsFewPlaces && item.FreePlaces === 0) {
        return mode === 'cell' ? this.getQuotaDescription.fewSeatsQuotaDescription : this.localizeList.fewPlaces;
      } else if (item.PlacesStatus === 1) {
        return mode === 'cell' ? this.getQuotaDescription.seatsQuotaDescription : this.localizeList.available;
      } else if (item.PlacesStatus === 2) {
        return mode === 'cell' ? this.getQuotaDescription.noSeatsQuotaDescription : this.localizeList.quotaHasNoPlaces;
      } else if (item.PlacesStatus === 4) {
        return mode === 'cell' ? this.getQuotaDescription.reqSeatsQuotaDescription : this.localizeList.onRequest
      }  else {
        return ""
      }
    },
    checkPlacesStatus(item) {
      if (!item.QuotaStatus) return;

      let placesStatus = item.QuotaStatus.PlacesStatus;
      const fewPlaces = item.QuotaStatus.IsFewPlaces;
      if (fewPlaces) placesStatus = 3;
      return placesStatus ? placesStatus : 0
    },
    setResult() {
      let quotes = JSON.stringify(this.getResultList);
      quotes = JSON.parse(quotes);

      this.quotesResultList = quotes;
    },
    checkRoomKey(item) {
      if (!item.Room.Key) {
        return this.localizeList.anyUpper
      } else {
        return item.Room.Value + ' ' + item.RoomCategory.Value
      }
    }
  },
  watch: {
    getResultList: {
        deep: true,
        handler() {
            this.setResult()
        }
    }
}
};
</script>

<style scoped>
  .result-group-wrap {
    text-align: center;
    padding: 20px 60px;
  }

  .result-group-wrap .result-city-title {
    margin-bottom: 20px;
  }

  .result-group {
    position: relative;
    background-color: var(--white-color);
    border: 1px solid var(--lighten-3-color);
    border-radius: 3px;
    padding: 20px;
  }

  .result-group:not(:last-child) {
    border-bottom: none;
  }

  .result-group::before {
    content: "";
    position: absolute;
    left: 225px;
    top: 0;
    width: 1px;
    height: 100%;
    background-color: var(--lighten-3-color);
  }

  .result-group::after {
    content: "";
    position: absolute;
    left: 275px;
    top: 0;
    width: 1px;
    height: 100%;
    background-color: var(--lighten-3-color);
  }

  .result-group:first-of-type:not(:only-of-type) {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }

  .result-group:last-child:not(:only-of-type) {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

  .result-group .result-hotel-title {
    margin-bottom: 20px;
  }

  .result-row {
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 14px;
  }

  .result-row:not(:last-child) {
    padding-bottom: 4px;
  }

  .result-row .result-name-block {
    flex: 0 0 200px;
    width: 200px;
    text-align: left;
    word-wrap: break-word;
  }

  .result-row .result-duration-block {
    display: flex;
    min-width: 50px;
    width: 50px;
    height: 30px;
    align-items: center;
    justify-content: center;
  }

  .result-quotes-block {
    flex: 1;
  }

  .result-quotes-block .quotes-list {
    display: grid;
    grid-template-columns: repeat(30, 50px);
    list-style-type: none;
    height: 30px;
  }

  .result-quotes-block .quotes-list :only-child {
     border-radius: 3px;
  }

  .result-quotes-block .quotes-list :first-child:not(:only-child) {
     border-radius: 3px 0 0 3px;
  }

  .result-quotes-block .quotes-list :last-child:not(:only-child) {
     border-radius: 0 3px 3px 0;
  }

  .result-quotes-block .quotes-list .quotes-list-item {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid var(--lighten-3-color);
    overflow: hidden;
    white-space: nowrap;
  }

  .result-quotes-block .quotes-list .quotes-list-item:not(:last-child) {
    border-right: none;
  }

  .result-quotes-block .quotes-list .quotes-list-item-color-0 {
    background-color: var(--white-color);
  }
  .result-quotes-block .quotes-list .quotes-list-item-color-1 {
    background-color: var(--green-4-color);
  }
  .result-quotes-block .quotes-list .quotes-list-item-color-2 {
    background-color: var(--red-color);
  }
  .result-quotes-block .quotes-list .quotes-list-item-color-3 {
    background-color: #319AE6;
  }
  .result-quotes-block .quotes-list .quotes-list-item-color-4 {
    background-color: var(--yellow-color);
  }
</style>
